/* eslint-disable no-unused-vars */

import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../../Axios/AxiosBaseQuery';
const URL = 'intern-service/profile/education';

// Create the API using createApi
export const GetEducationApi = createApi({
  reducerPath: 'GetEducationApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Education'],
  staleTime: 1,
  endpoints: (builder) => ({
    getEducation: builder.query({
      query: () => ({ url: URL, method: 'GET' }),
      providesTags: ['Education'],
    }),
    saveCertification: builder.mutation({
      query: ({ ...body }) => {
        let url = 'intern-service/profile/education/certification';
        let method = 'POST';
        return { url, method, body };
      },
      invalidatesTags: ['Education'],
    }),
    updateCertification: builder.mutation({
      query: ({ id, ...body }) => {
        let url = `intern-service/profile/education/certification/${id}`;
        let method = 'PATCH';

        return { url, method, body };
      },
      invalidatesTags: ['Education'],
    }),
    updateEducation: builder.mutation({
      query: ({ id, ...body }) => {
        let url = '';
        let method = '';
        if (!id) {
          url = 'intern-service/profile/education';
          method = 'POST';
        } else {
          url = `intern-service/profile/education/${id}`;
          method = 'PUT';
        }
        return { url, method, body };
      },
      invalidatesTags: ['Education'],
    }),
    deleteCertification: builder.mutation({
      query: (id) => ({
        url: `intern-service/profile/education/certification/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Education'],
    }),
    deleteEducation: builder.mutation({
      query: (id) => ({
        url: `intern-service/profile/education/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Education'],
    }),
    getEducationDetailById: builder.query({
      query: (id) => ({
        url: `intern-service/profile/education/${id}`,
        method: 'GET',
      }),
    }),
    getCertificateDetailById: builder.query({
      query: (id) => ({
        url: `intern-service/profile/education/certification/${id}`,
        method: 'GET',
      }),
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetEducationQuery,
  useUpdateCertificationMutation,
  useUpdateEducationMutation,
  useDeleteCertificationMutation,
  useDeleteEducationMutation,
  useLazyGetEducationDetailByIdQuery,
  useLazyGetCertificateDetailByIdQuery,
  useSaveCertificationMutation,
} = GetEducationApi;
// Export the auto-generated hooks and reducer
export default GetEducationApi.reducer;
